let configProd = {
  baseApi: 'https://api-dqs.alphalyr.com',
  client_id: '1_5e46e7ltdaldfgldfc0o4co8gc4g4co4gcsco4g0sk',
  client_secret: '2a3mabu1b6dsdzefrgthjh480g8go0ggwggo8wokwg40gkk',
  files: 'clientFilesPath'
};

export var config = configProd



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/common/config/config.ts